import PaymentController from '../../api/controllers/paymentController';
import {
  paymentEnterMobileActionType,
  paymentInitActionType,
  errorBlockTransactionDisplay,
} from '../../actionTypes';
import { tracker, initializeTracker } from '../../tracking';
import onTransactionErrorBlock from '../onTransactionErrorBlock';
import getTransactionExperimentData from './getTransactionExperimentData';
import Utils from '../../utils';
import { posCustomerPaymentSuccessRoute } from '../../alias/paymentRoutes';
import { route } from 'preact-router';
import { isLenderDetailsListForNtb } from '../../utils/helper';

export default (actionPayload) => (dispatch, getState) => {
  const { pageKey } = getState().config || {};
  const { txnUuid, mobile, sourceRef } = actionPayload || {};

  const updateTxnTerminationData = (displayPaymentContainer, txnTerminated) => {
    dispatch({
      type: paymentInitActionType.UPDATE_TXN_TERMINATION_DATA,
      payload: { displayPaymentContainer, txnTerminated },
    });
  };

  dispatch({
    type: paymentInitActionType.TRANSACTION_INFO_REQUEST,
    payload: { txnUuid },
  });
  const data = {
    pgTxnInfoUuid: txnUuid,
    mobile,
  };
  return PaymentController.getTransactionInfoController(data, { sourceRef })
    .then((res) => {
      const {
        gatewayMerchantId: merchantId,
        mobile: mobileNo,
        isEligible,
        purchaseValue,
        lenderDetailsList,
        payLaterLenderDetailsList,
        selectedLenderDetails,
        userStatus,
        returnUrl,
        remainingTimeSeconds,
        pgData,
        isOfferEligible,
        timeoutErrorModel,
        channel,
        isNoCostEmiAvailable,
        merchantName,
        txnTerminated,
        merchantDetails,
        skipNtbPreEligibility,
      } = res.data || {};
      const { merchantLogoUrl } = merchantDetails || {};

      dispatch(getTransactionExperimentData());
      dispatch({
        type: paymentInitActionType.TRANSACTION_TIMEOUT_STORE,
        payload: { pgData, returnUrl },
      });
      if (timeoutErrorModel) {
        const {
          cta = '',
          errorType = '',
          helpText = '',
          message = '',
          title = '',
        } = timeoutErrorModel || {};
        dispatch({
          type: errorBlockTransactionDisplay.DISPLAY_HELP_TEXT,
          payload: { helpText, title, message, cta, errorType },
        });
      }

      initializeTracker();

      if (mobileNo) {
        if (
          !isEligible &&
          (selectedLenderDetails == undefined ||
            !selectedLenderDetails.isNtbLender) &&
          (!lenderDetailsList || !isLenderDetailsListForNtb(lenderDetailsList))
        ) {
          //NON-eligible
          setTimeout(() => {
            const message = `The entered mobile is not eligible with any of our banking partners`;
            dispatch({
              type:
                paymentEnterMobileActionType.UPDATE_TRANSACTION_MOBILE_NUMBER_ERROR,
              payload: {
                mobileNoError: message,
              },
            });

            tracker.trackApplicationError(
              'SuD Not Eligible',
              pageKey || 'Missing pageKey',
            );
          }, 0);
        } else if (selectedLenderDetails) {
          //dispatch mobile-number and transaction details
          //pre-selected lender details
          const { emiDetails, lenderType } = selectedLenderDetails;
          emiDetails['lenderType'] = lenderType;
          dispatch({
            type: paymentInitActionType.TRANSACTION_INFO_PRE_SELECTED_SUCCESS,
            payload: {
              merchantId,
              mobile: mobileNo,
              purchaseValue,
              selectedLender: selectedLenderDetails,
              selectedEmiDetails: emiDetails,
            },
          });
        }
      }
      const detailsTimestampSeconds = Math.round(new Date().getTime() / 1000);
      dispatch({
        type: paymentInitActionType.TRANSACTION_INFO_SUCCESS,
        payload: {
          eligible: isEligible,
          merchantId,
          mobile: mobileNo,
          purchaseValue,
          userStatus,
          lenderDetailsList: lenderDetailsList || [],
          payLaterLenderDetailsList: payLaterLenderDetailsList || [],
          selectedLenderType:
            Array.isArray(lenderDetailsList) &&
            lenderDetailsList.length &&
            Array.isArray(payLaterLenderDetailsList) &&
            payLaterLenderDetailsList.length
              ? ''
              : Array.isArray(lenderDetailsList) && lenderDetailsList.length
              ? 'EMI'
              : Array.isArray(payLaterLenderDetailsList) &&
                payLaterLenderDetailsList.length
              ? 'PAY_LATER'
              : '',

          selectedLender: selectedLenderDetails,
          remainingTimeSeconds,
          isFlipkartOfferEligible: isOfferEligible,
          channel,
          isNoCostEmiAvailable,
          detailsTimestampSeconds,
          merchantName,
          merchantLogoUrl,
          skipNtbPreEligibility,
        },
      });

      if (txnTerminated && !sourceRef) {
        let displayPaymentContainer = true;
        switch (channel) {
          case 'ONLINE':
            displayPaymentContainer = false;
            updateTxnTerminationData(displayPaymentContainer, txnTerminated);

            const utils = new Utils();
            utils.createAndSubmitDynamicForm(pgData, returnUrl, 0);
            break;

          case 'OFFLINE':
            updateTxnTerminationData(displayPaymentContainer, txnTerminated);
            route(
              `${posCustomerPaymentSuccessRoute.path}${window.location.search}`,
              true,
            );
            break;
        }
      }
    })
    .catch(({ data }) => {
      const { errorData, message, cta, errorType, helpText, title } =
        data || {};

      //In case of exceptions, we don't redirect to Enter-Mobile Screen.
      dispatch({
        type: paymentInitActionType.UPDATE_REDIRECT_TO_ENTER_MOBILE,
        payload: false,
      });

      const { pgData, returnUrl, channel } = errorData || {};

      dispatch({
        type: paymentInitActionType.TRANSACTION_INFO_ERROR,
        payload: { pgData, returnUrl, channel },
      });

      dispatch(
        onTransactionErrorBlock({ cta, errorType, helpText, title, message }),
      );
    });
};



// WEBPACK FOOTER //
// ./components/transaction/src/actions/onPaymentInit/getTransactionInfo.js